// extracted by mini-css-extract-plugin
module.exports = {"right":"style__right__C-3qd","wrong":"style__wrong__HuRer"};